//import SelectDateController from "../ReuseComps/SelectDateController";
import DateController from "../ReuseComps/DateController";

export default function SelectDateBones() {

  return (

    <DateController
        category = "bones_health"  
       />  

  );
}
